import ModelApi from "./ModelApi";

export default class CoGenConfigApi extends ModelApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "co_gen_config/";
	}

	retrieve(facility_url, onSuccess, onError) {

		const url = facility_url.replace("facilities", "co_gen_config");
		this.Get(url, onSuccess, onError);
	}


}
